import { supabase } from "@/integrations/supabase/client";

/** Single source of truth for store / install links. */
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/airport-buddy/id6761429753";

/** True when the visitor is on an iPhone/iPad in a normal web browser. */
export function isIOSWebBrowser(): boolean {
  if (typeof window === "undefined") return false;
  const ua = window.navigator?.userAgent ?? "";
  const isIOSDevice =
    /iPhone|iPad|iPod/i.test(ua) ||
    // iPadOS 13+ reports as Mac with touch support
    (/Macintosh/i.test(ua) && (navigator as any).maxTouchPoints > 1);
  return isIOSDevice;
}

export function getDeviceLabel(): string {
  if (typeof window === "undefined") return "unknown";
  const ua = window.navigator?.userAgent ?? "";
  if (isIOSWebBrowser()) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
}

/**
 * Fire-and-forget analytics for app CTA taps. Never blocks or throws.
 */
export function trackCtaClick(placement: string, context?: string) {
  try {
    // Mirror into the product-usage log (dynamic import avoids a cycle).
    void import("@/lib/productEvents").then(
      (m) => m.trackEvent("app_cta_click", placement),
      () => undefined,
    );
    void supabase
      .from("app_cta_clicks" as any)
      .insert({ placement, context: context ?? null, device: getDeviceLabel() } as any)
      .then(
        () => undefined,
        () => undefined,
      );
  } catch {
    /* ignore */
  }
}
